import { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { newRole } from "../../../../store/roles_skills";

interface Props {
  isShown: boolean;
  toggle: any;
}

type FormValues = {
  role: string;
  slug: string;
  description: string | null;
};

const NewRole = ({ isShown, toggle }: Props) => {
  const dispatch = useAppDispatch();
  const { register, handleSubmit } = useForm<FormValues>();

  const { status } = useAppSelector((state) => state.roles_skills);

  const onSubmit: SubmitHandler<FormValues> = async (data: any) => {
    dispatch(newRole({ data: data }));
  };

  useEffect(() => {
    if (status === "newRole_success" && isShown) {
      toggle();
    }
  }, [status]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="c-form-report">
        <div className="c-form-report__input-box" style={{ marginTop: "10px" }}>
          <span className="c-form-report__text-input">Role Name</span>
          <input
            type="text"
            className="c-form-report__input-value"
            style={{ color: "black" }}
            {...register("role")}
          />
        </div>

        <div className="c-form-report__input-box">
          <span className="c-form-report__text-input">Role Slug</span>

          <input
            type="text"
            className="c-form-report__input-value"
            style={{ color: "black" }}
            {...register("slug")}
          />
        </div>
        <div className="c-form-report__input-box">
          <span className="c-form-report__text-input">Role Description</span>
          <textarea
            className="c-form-report__input-value c-form-report__input-value--area"
            style={{ color: "black" }}
            {...register("description")}
          />
        </div>
        <div className="c-form-report__footer">
          <button type="submit" className="c-form-report__button-submit">
            Save Changes
          </button>
        </div>
      </form>
    </>
  );
};

export default NewRole;
